var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, state } from 'lit/decorators.js';
import { html, css, nothing } from 'lit';
import { GGOBaseComponent } from "../ggo.base.component.js";
let ColumnFillerComponent = class ColumnFillerComponent extends GGOBaseComponent {
    constructor() {
        super(...arguments);
        this._columnsData = [];
        this.selected = [];
        this.available = [];
        this.openDropdown = [];
    }
    get columnsData() {
        return this._columnsData;
    }
    set columnsData(value) {
        this._columnsData = value ?? [];
        this.selected = this._columnsData.map(() => []);
        this.available = this._columnsData.map(col => [...col.values]);
        this.openDropdown = this._columnsData.map(() => false);
        this.requestUpdate();
    }
    render() {
        return html `
      <div class="ggo-grid">
        ${this.columnsData.map((col, colIdx) => html `
          <div class="ggo-column">
            <div class="ggo-header">${col.label}</div>
            <div class="ggo-cells">
              ${this.selected[colIdx]?.map(item => html `
                <div class="ggo-cell-row">
                  <span class="ggo-cell-label">${item.label}</span>
                  <button class="ggo-remove-btn" @click=${() => this.handleRemove(colIdx, item)} title="Supprimer">
                    <ggo-icon icon="delete" color="red"></ggo-icon>
                  </button>
                </div>
              `)}
              <div class="ggo-cell-row ggo-add-row">
                <span class="ggo-cell-label"></span>
                <div class="ggo-add-container-center">
                  ${this.openDropdown[colIdx] && this.available[colIdx].length > 0 ? html `
                    <div class="ggo-dropdown">
                      ${[...this.available[colIdx]]
            .sort((a, b) => a.label.localeCompare(b.label))
            .map(item => html `
                          <div 
                            class="ggo-dropdown-item" 
                            title="${item.label}" 
                            @click=${() => this.handleSelect(colIdx, item)}
                          >
                            <span style="flex:1; min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">${item.label}</span>
                          </div>
                        `)}
                    </div>
                  ` : nothing}
                  <button
                    class="ggo-add-btn"
                    @click=${() => this.handleAddClick(colIdx)}
                    ?disabled=${this.available[colIdx].length === 0}
                    title="Ajouter"
                  >+</button>
                </div>
              </div>
            </div>
          </div>
        `)}
      </div>
    `;
    }
    static get styles() {
        return [
            ...super.styles,
            css `
        .ggo-grid {
          display: flex;
          gap: 1.5rem;
          margin-top: 1rem;
          width: 100%;
        }
        .ggo-column {
          display: flex;
          flex-direction: column;
          align-items: stretch;
          flex: 1 1 0;
          min-width: 120px;
          background: #f8f9fa;
          border-radius: 8px;
          padding: 1rem 0.5rem;
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
          position: relative;
        }
        .ggo-header {
          font-weight: bold;
          margin-bottom: 0.5rem;
          color: #03234D;
          text-align: center;
        }
        .ggo-cells {
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
        }
        .ggo-cell-row {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          min-height: 2.2rem;
          background: transparent;
          margin: 0;
          padding: 0 0.25rem;
          border-radius: 4px;
          font-size: 0.95rem;
        }
        .ggo-add-row {
          justify-content: center;
        }
        .ggo-cell-label {
          flex: 1;
          color: #03234D;
        }
        .ggo-remove-btn {
          background: none;
          border: none;
          color: #d32f2f;
          font-size: 1.1rem;
          cursor: pointer;
          margin-left: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 2.2rem;
          width: 2.2rem;
          padding: 0;
        }
        .ggo-add-container-center {
          position: relative;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          width: 2.2rem;
        }
        .ggo-add-btn {
          font-size: 1.2rem;
          padding: 0;
          width: 2.2rem;
          height: 2.2rem;
          cursor: pointer;
          border: none;
          background: #007bff;
          color: #fff;
          border-radius: 4px;
          transition: background 0.2s;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .ggo-add-btn:disabled {
          background: #ccc;
          cursor: not-allowed;
        }
        .ggo-dropdown {
          position: absolute;
          top: 100%;
          right: 0;
          z-index: 10;
          background: #fff;
          border: 1px solid #ccc;
          border-radius: 4px;
          margin-top: 0.25rem;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
          max-height: calc(2.8rem * 7); 
          overflow-y: auto;
          min-width: 200px; 
          width: 110%;
          max-width: 300px;
        }
        @media (max-width: 600px) {
          .ggo-dropdown {
            min-width: 100px;
            width: 100%;
            max-width: 200px;
            max-height: calc(2.8rem * 6); 
          }
        }
        .ggo-dropdown-item {
          padding: 0.5rem 1rem;
          cursor: pointer;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          height: 2.8rem;
          display: flex;
          align-items: center;
          width: 100%;    
          box-sizing: border-box;
        }
        .ggo-dropdown-item:hover {
          background: #f0f0f0;
        }
      `
        ];
    }
    handleAddClick(colIdx) {
        this.openDropdown = this.openDropdown.map((open, idx) => idx === colIdx ? !open : false);
    }
    handleSelect(colIdx, item) {
        this.selected = this.selected.map((col, idx) => idx === colIdx ? [...col, item] : col);
        this.available = this.available.map((col, idx) => idx === colIdx ? col.filter(v => v.alias !== item.alias) : col);
        this.openDropdown = this.openDropdown.map((open, idx) => idx === colIdx ? false : open);
        this.dispatchEvent(new CustomEvent('change', { detail: { selected: this.selected } }));
    }
    handleRemove(colIdx, item) {
        const original = this.columnsData[colIdx].values;
        this.selected = this.selected.map((col, idx) => idx === colIdx ? col.filter(v => v.alias !== item.alias) : col);
        this.available = this.available.map((col, idx) => idx === colIdx
            ? [...col, item].sort((a, b) => original.findIndex(o => o.alias === a.alias) - original.findIndex(o => o.alias === b.alias))
            : col);
        this.dispatchEvent(new CustomEvent('change', { detail: { selected: this.selected } }));
    }
};
__decorate([
    property({ type: Array })
], ColumnFillerComponent.prototype, "columnsData", null);
__decorate([
    state()
], ColumnFillerComponent.prototype, "selected", void 0);
__decorate([
    state()
], ColumnFillerComponent.prototype, "available", void 0);
__decorate([
    state()
], ColumnFillerComponent.prototype, "openDropdown", void 0);
ColumnFillerComponent = __decorate([
    customElement('ggo-column-filler')
], ColumnFillerComponent);
export { ColumnFillerComponent };
